module.exports = __webpack_public_path__ + "img/kr.b36d80c0.svg";